import React from 'react'

type Props = {}

const BoasVindas = (props: Props) => {
  return (
    <div>

<main className="boasVindasAoSite">
            <h2 className='subtituliMainBoasVindas'>Welcome to Local Face</h2>

          <p className="textoMainBoasvindas">
            Welcome to Local Face Perfumes, where the spirit of victory and triumph come alive through scents that empower and inspire.  <br />
            Our curated collection, aptly named "Victory Scented," is a celebration of success and elegance, designed to unleash your<br />
            victorious essence. Indulge in the sweet taste of triumph with captivating fragrances that tell the tale of your achievements.<br />
            At Local Face, we believe that every victory deserves a signature scent, and we are dedicated to providing unforgettable
            fragrances that elevate your spirit and empower your journey.</p>

        </main>
    </div>
  )
}

export default BoasVindas